module.exports = __webpack_public_path__ + "img/icon_yunying@3x.14176b81.png";